import { render } from "./SubscriptionComponent.vue?vue&type=template&id=82324872&ts=true"
import script from "./SubscriptionComponent.vue?vue&type=script&lang=ts"
export * from "./SubscriptionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__